Agent_data_oncloud = {
	p_call_list: []
	,
	init : function(){
	}
	,
	get_data : function( pm_url = '', pm_config = {} )
	{
		// Get service path to retrieve property service data.
		var request_url = oc__oncloud_settings.url + pm_url;
		
		// Disallow repeated calls. One call per service.
		let allow_call = ( Agent_data_oncloud.p_call_list.indexOf(request_url) < 0 );
		if( !allow_call )
		{
			//console.log('ALREADY LOADING DATA FOR: ',request_url);
			return(false);
		}
		
		// Assemble options for data call.
		var config = pm_config;
		
		// Add the call to the call list. 
		Agent_data_oncloud.p_call_list.push(request_url);
		
		jQuery.ajax({
			type: "POST",
			url: request_url,
			contentType: "text/plain; charset=utf-8",
			dataType: "json",
			data: JSON.stringify( config ),
			success: function( data, status, jqXHR ){
				// Emit event. After OnCloud Property Service data retrieval.
				var response = {};
				response.success = true;
				response.url = request_url;
				response.config = config;
				response.data = data;
				jQuery(document).trigger('oc_agent_data_retrieval',response);
			}
		});
	}
}

jQuery(document).ready(function(jQuery){
	Agent_data_oncloud.init();
});